const getTextWithSpecialWordbreaks = (htmlText: string): string =>
  htmlText.replace(/([^<]\/)/g, '$1&ZeroWidthSpace;').replace(/\s/g, '&nbsp;');

export default getTextWithSpecialWordbreaks;
